import React from 'react';
import { useForm } from 'react-hook-form';
import { ActionButton } from 'components/ui/Button';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { voucherReferenceReg } from 'utils/validators';

import { StyledInput, MandatoryFieldLabel, ErrorField, Field, StyledSubmitField, StyledForm } from './ManageVoucher.styles';

const SearchVoucherByCodeForm = ({ onSubmitSearch }) => {
  const { register, handleSubmit, formState } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { errors } = formState;

  return (
    <StyledForm onSubmit={handleSubmit(onSubmitSearch)}>
      <Field>
        <MandatoryFieldLabel htmlFor="voucherCode">
          <FormattedMessage id="payments.EvoucherReference" />
        </MandatoryFieldLabel>
        <StyledInput
          {...register('voucherCode', {
            required: true,
            pattern: voucherReferenceReg
          })}
          type="text"
          id="voucherCode"
          maxLength="16"
          validationState={errors.voucherCode ? 'error' : ''}
        />
        {errors.voucherCode && (
          <ErrorField id="error-voucher-code">
            <FormattedMessage id="payments.voucherIsNotANumber" />
          </ErrorField>
        )}
      </Field>
      <StyledSubmitField>
        <ActionButton data-cy="voucher-code-search" type="submit" disabled={!formState.isValid}>
          <FormattedMessage id="vouchers.search" />
        </ActionButton>
      </StyledSubmitField>
    </StyledForm>
  );
};

SearchVoucherByCodeForm.propTypes = {
  onSubmitSearch: PropTypes.func
};

export default SearchVoucherByCodeForm;
